module.exports = __webpack_public_path__ + "img/favicons/cha/android-chrome-192x192.png";